import { AppError } from "@/core/common/http/errors/app.error";

export class RequestTimeoutError extends AppError {
  constructor(message: string, url: string) {
    super(message, 504, "Request Timeout", url, "El servidor está tardando demasiado en responder");
  }
}
